<template>
  <div class="inputtext-container">
    <input class="input-text" :value="modelValue" @input="input($event.target)" v-bind="$attrs" :class="{ error: error }"
      v-bind:disabled="disabled" :autocomplete="autocomplete">
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: [String, Number]
    },
    error: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: null
    }
  },
  setup(props, context) {
    const input = (target: EventTarget | null) => {
      target as HTMLInputElement
      if (target instanceof HTMLInputElement) {

        context.emit('update:modelValue', target.value)
      }
    }
    return {
      input
    }
  },
  // props: ["modelValue", "error", "disabled"],
  emits: ['update:modelValue']
})
</script>
